import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../hook/useRulesContext";
import Header from "./Header";
import Controls from "./Controls";
import RulesTable from "./RulesTable";
import RuleModal from "../add/RuleModal";

export default function RulesList() {
    const { showAddModal } = useRulesContext();

    return (
        <div className="mx-auto p-3 sm:p-6 bg-gray-50 min-h-screen">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                {/* Header */}
                <Header />
                {/* Filter Controls */}
                <Controls />
                {/* Rules CRUD Table */}
                <RulesTable />
            </div>
            {/* Add/edit shortcode modal */}
            {showAddModal && <RuleModal />}
        </div>
    );
}
